function listenToPusherUserChannel(handler) {
  window.pusherUserChannel.listen('.sync-event', handler);
}

export function listenToPusherSyncEvents(handler) {
  if (window.pusherUserChannel) {
    listenToPusherUserChannel(handler);
  } else {
    window.addEventListener('message', ({data}) => {
      if (data && data.type === 'pusherUserChannel') {
        listenToPusherUserChannel(handler);
      }
    });
  }
}
